/* eslint-disable no-await-in-loop */
import React from 'react';
import { Portal } from '@leverege/ui-elements';
import Constants from "../Constants.js";
import MoltenUtil from "../MoltenUtil.js";
import MoltenRoot from "./MoltenRoot.js";
import MoltenProvider from "./MoltenProvider.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
async function run(molten) {
  // Supply an easy mechanism for initializers to render the current root
  const moltenRef = /*#__PURE__*/React.createRef();
  const rootComponent = /*#__PURE__*/_jsxs(MoltenProvider, {
    molten: molten,
    children: [/*#__PURE__*/_jsx(MoltenRoot, {
      ref: moltenRef,
      molten: molten
    }), /*#__PURE__*/_jsx(Portal, {
      id: "moltenPortalRoot"
    })]
  }, "molten.provider");
  const pRender = molten.render(rootComponent);
  if (pRender?.then) {
    await pRender;
  }
  molten.set('setRootComponent', component => moltenRef.current.setComponent(component));

  // Run the initializers
  await MoltenUtil.invokeMoltenCallbacks(Constants.INITIALIZER, 'init', molten);

  // Get the base application class
  const appClass = molten.get('molten/authScreenClass') ||
  // set by initializer?
  molten.getConfig('molten/authScreenClass') || molten.getAppClass?.();
  let app = [/*#__PURE__*/React.createElement(appClass, {
    key: 'molten.app',
    molten
  }), MoltenUtil.sortedPlugins(Constants.SUPPORT_COMPONENTS).map(s => s.createSupportComponents(molten)).flat()];

  // Build the provider tree bottom up so app is contained by 
  // all the other providers
  const providers = MoltenUtil.sortedPlugins(Constants.PROVIDER);
  for (let n = providers.length - 1; n >= 0; n--) {
    const p = providers[n].createProvider(molten, app);
    if (typeof p.then === 'function') {
      app = await p;
    } else {
      app = p;
    }
  }

  // Run the prerender calls
  await MoltenUtil.invokeMoltenCallbacks(Constants.PRERENDER, 'onPrerender', molten);

  // Render the app
  moltenRef.current.setState({
    component: app
  });
}
export default {
  run
};